import { useLocation, useNavigate } from 'react-router';
import { ArrowRight } from 'lucide-react';
import { useLiveQuery } from 'dexie-react-hooks';
import { Banner } from '@/components/Banner';
import { Button } from '@/components/Button';
import { leerSettings, hayDatosCapturados } from '@/db/schema';
import { evaluarRespaldo } from '@/domain/backup-reminder';

export const RUTA_RESPALDOS = '/mas/respaldos';

/**
 * Recordatorio de respaldo pendiente (Req. 7.1, 7.2, 7.4, 7.5).
 *
 * Vive en el armazón para verse en todas las pantallas salvo Respaldos. Es un
 * aviso dentro de la app: no hay notificaciones del sistema.
 *
 * Origen: Control de Negocio de Comida.
 */
export function BackupBanner() {
  const navegar = useNavigate();
  const { pathname } = useLocation();

  // Solo lecturas: useLiveQuery corre en una transacción de solo lectura.
  const estado = useLiveQuery(async () => {
    const settings = await leerSettings();
    return evaluarRespaldo({
      ultimoRespaldoEn: settings.ultimoRespaldoEn,
      hayDatos: await hayDatosCapturados(),
      diasAviso: settings.diasAvisoRespaldo,
    });
  }, []);

  if (estado === undefined || !estado.debeAvisar) return null;
  // Tampoco en sus pantallas internas: restaurar, cifrado y copias
  if (pathname === RUTA_RESPALDOS || pathname.startsWith(`${RUTA_RESPALDOS}/`)) return null;

  return (
    <Banner
      tono={estado.nivel === 'alerta' ? 'alerta' : 'aviso'}
      titulo={estado.mensaje}
      accion={
        <Button completo={false} icono={ArrowRight} onClick={() => void navegar(RUTA_RESPALDOS)}>
          Hacer respaldo
        </Button>
      }
    >
      {estado.detalle}
    </Banner>
  );
}
